<template>
	<div class="main-content">
		<Breadcrumb class="bread">
			<BreadcrumbItem class="main-title">
				<span>{{$options.filters.I18nColumn(step,'Name')}}</span>
				<Icon type="md-arrow-dropright" color="dodgerblue"/>
				<span style="font-size:13px">{{$t('開放時間')}}</span>
				<span
					style="font-size:18px"
					class="ml-8"
				>{{step.StartTime | DateTime}} - {{step.EndTime | DateTime}}</span>
			</BreadcrumbItem>
		</Breadcrumb>
		<Card class="card-step">
			<div slot="title">
				<Icon type="ios-arrow-down"></Icon>
				<strong class="ml-8">{{$t('填寫說明')}}</strong>
			</div>
			<div class="description" v-html="$options.filters.I18nColumn(step,'Description')"></div>
		</Card>
		<br>
		<ApplicationForm id="applicationForm"/>
	</div>
</template>
<script>
import ApplicationForm from './ApplicationForm.vue'
import { STEP } from '@/models/Step.ts'
export default {
	components: {
		ApplicationForm,
	},
	data: function() {
		return {
			flowId: this.$route.params.flowId,
			step: Object.assign({}, STEP),
		}
	},
	mounted() {
		this.getStep()
	},
	methods: {
		async getStep() {
			try {
				let response = await this.$http.get(`api/FreshmanApplication/${this.flowId}`)
				this.step = response.data
			} catch (err) {
				this.$Message.error(this.$t('查無資料'))
			}
		},
	},
}
</script>
<style lang="scss" scoped>
.description {
	margin: 0 10px 0 10px;
}
.title {
	margin-top: 14px;
}
.step-detail {
	font-family: MicrosoftJhengHeiRegular;
	margin: 10px 0px 0px 10px;
}
.ivu-divider {
	margin: 14px 0px 0px 0px;
}
.ivu-icon-ios-arrow-forward {
	color: dodgerblue;
}
.ivu-form-item {
	margin-bottom: 10px;
	margin-top: 10px;
}
.ivu-col {
	padding-right: 10px;
}
.pr-10 {
	padding-right: 10px;
}
</style>
